import { render, staticRenderFns } from "./greeting.vue?vue&type=template&id=72940f3a&scoped=true&"
import script from "./greeting.vue?vue&type=script&lang=js&"
export * from "./greeting.vue?vue&type=script&lang=js&"
import style0 from "./greeting.vue?vue&type=style&index=0&id=72940f3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72940f3a",
  null
  
)

component.options.__file = "greeting.vue"
export default component.exports